var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCollapsed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.033,
    height: 30.033,
    viewBox: "0 0 30.033 30.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#fff}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "rotate(45 45.811 -88.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    className: "cls-1",
    d: "m1103.877 96.43 2.63-2.617-3.627-3.613h-5.136l-6.244 6.23 6.244 6.244h5.246l-6.244-6.244 3.572-3.558z",
    transform: "translate(-1009.292 -89.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    className: "cls-1",
    d: "M1208.65 90.2h-5.25l6.244 6.23-3.556 3.57-3.572-3.572-2.617 2.63 3.613 3.613h5.136l6.244-6.244z",
    transform: "translate(-1102.685 -89.954)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCollapsed);
export default __webpack_public_path__ + "static/media/logo-collapsed.77565847f3cee84ace15119e72c8f8af.svg";
export { ForwardRef as ReactComponent };